import setCookie from "@/utils/setCookie"
import { ContactTokens } from '../../../../requests-module'

const AUTH_COOKIE_TTL_DAYS = 7

const setTokensInCookies = (tokens: ContactTokens) => {
    setCookie('user-access-token', tokens.accessToken, '/', AUTH_COOKIE_TTL_DAYS)
    setCookie('user-id-token', tokens.idToken, '/', AUTH_COOKIE_TTL_DAYS)
    setCookie('user-refresh-token', tokens.refreshToken, '/', AUTH_COOKIE_TTL_DAYS)
}

export default setTokensInCookies